import { Assert } from '@team/assert';
import { ZERO } from './const.js';

export function isZero(value: number) {
  return Assert.isEquals(ZERO, value);
}
